import React from "react"
import QuestionSearchContainer from "../../containers/QuestionSearchContainer"

const QuestionSearchPage = () => {
  return <QuestionSearchContainer />
}
export default QuestionSearchPage
